import React, { useCallback, useEffect, useReducer, useState } from "react"
import { pesquisarBrindesResgatados } from "../../../services/brindesResgatados"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { BrindesResgatadosFornecedorActionsTypes } from "./brindesResgatadosFornecedorActions"
import { BrindesResgatadosFornecedorContext } from "./BrindesResgatadosFornecedorContext"
import {
    BrindesResgatadosFornecedorInicial,
    brindesResgatadosFornecedorReducer,
} from "./brindesResgatadosFornecedorReducer"

export function BrindesResgatadosFornecedorContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        brindesResgatadosFornecedorReducer,
        BrindesResgatadosFornecedorInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await pesquisarBrindesResgatados(
                autorizacao,
                dados.parteNome,
                dados.email
            )
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar brindes")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: BrindesResgatadosFornecedorActionsTypes.CARREGAR,
                    payload: response,
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar brindes")
        } finally {
            setLoading(false)
        }
    }, [dados.parteNome, dados.email])

    useEffect(() => {
        pesquisar()
    }, [])

    return (
        <BrindesResgatadosFornecedorContext.Provider
            value={{ dados, dispatch, pesquisar, erroCarregamento }}
        >
            <Loading />
            {children}
        </BrindesResgatadosFornecedorContext.Provider>
    )
}
